import * as Sentry from "@sentry/react";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const isDev = import.meta.env.DEV;

if (!isDev) {
  try {
    Sentry.init({
      dsn: "https://7c8ea01b2b243ffb6e38e630d5a251e0@o4508619046518784.ingest.us.sentry.io/4508619051237376",
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ["error"],
        }),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [/^\//, /^https:\/\/tokens.tradyfi\.io/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      release: import.meta.env.VERSION,
    });
  } catch (error) {
    console.error("Failed to initialize Sentry:", error);
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
